import { configureStore } from '@reduxjs/toolkit';
import canvas from '../store/reducers/canvasSlice';
import activeSheet from '../store/reducers/activeSheet';
import sheetTemplates from '../store/reducers/sheetTemplates';
import availableSheets from '../store/reducers/availableSheets';
import textValue from '../store/reducers/TextValue';
import userImagesList from './reducers/userImagesListSlice';
import templateDataList from './reducers/templateDataSlice';
import panelKey from './reducers/panleKey';
import objectState from './reducers/objectState';
import modalToggle from './reducers/modalToggler';
import loginSlice from './reducers/loginSlice'
import colorSlice from './reducers/colorReducer'
import colorPickerReducer from './reducers/gradientSlice';
import notificationSlice  from "./reducers/notificationSlice";
import {combineReducers} from "redux";

const reducer = combineReducers({
    canvas,
    activeSheet,
    sheetTemplates,
    availableSheets,
    textValue,
    userImagesList,
    templateDataList,
    panelKey,
    objectState,
    modalToggle,
    loginSlice,
    colorSlice,
    colorPickerReducer,
    notificationSlice
})

export const Store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  })
